import React, { useContext, useMemo, useState } from 'react'
import { Grid, Button, Box } from '@mui/material'

import { translate } from '../i18n'
import { updatePassword } from '../api'
import { PasswordRequest } from '../model'
import { ConfirmPasswordValidator } from '../validators'
import { FeedbackContext } from '../feedback'
import { AnyInput, useValidatedForm } from '../anyform'
import { Surface, PasswordIcon } from '../components'

export default function UserPasswordForm() {
    const feedbackContext = useContext(FeedbackContext)
    const { register, bind, isValid, setPristine } =
        useValidatedForm<PasswordRequest>()
    const [password, setPassword] = useState<string>()

    const validators = useMemo(() => {
        return [new ConfirmPasswordValidator(() => password ?? '')]
    }, [password])

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (!isValid()) {
            return
        }

        feedbackContext.showBackdrop()

        const request = bind()
        updatePassword(request)
            .then((_response) => {
                feedbackContext.showSuccess(
                    translate('users.security.updated_password') as string
                )
                setPristine()
            })
            .catch((error) => feedbackContext.showError(error.message))
            .finally(feedbackContext.closeBackdrop)
    }

    return (
        <Surface
            title={translate('users.security.password') as string}
            icon={<PasswordIcon />}
        >
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                alignContent="center"
            >
                <Grid item xs={12}>
                    <form autoComplete="off" noValidate onSubmit={onSubmit}>
                        <Grid container>
                            <Grid item xs={12}>
                                <AnyInput
                                    type="password"
                                    name="old_password"
                                    label={
                                        translate(
                                            'users.old_password'
                                        ) as string
                                    }
                                    register={register}
                                    required
                                />
                                <AnyInput
                                    type="password"
                                    name="password"
                                    label={
                                        translate('users.password') as string
                                    }
                                    register={register}
                                    notifier={(name, value) =>
                                        setPassword(`${value ?? ''}`)
                                    }
                                    required
                                />
                                <AnyInput
                                    type="password"
                                    name="confirm_password"
                                    label={
                                        translate(
                                            'users.confirm_password'
                                        ) as string
                                    }
                                    register={register}
                                    required
                                    validators={validators}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box my={2}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        size="large"
                                    >
                                        {translate('buttons.update')}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </Surface>
    )
}
